import BigNumber from 'bignumber.js'

export const calculateDifference = (a: number, b: number, decimalPlaces: number = 6): number => {
	const x = new BigNumber(a.toString())
	const y = new BigNumber(b.toString())
	return x.minus(y).dp(decimalPlaces).toNumber()
}
